export const constants = {
    /* Confirmation Dialog */
    deleteMessage: 'Are you sure you want to Delete?',
    deleteMultipleValidation: 'Are you sure you want to delete the selected validations ?',
    deleteMultipleSchedule: 'Are you sure you want to delete the selected schedules ?',
    deleteMultipleInstruction: 'Are you sure you want to delete the selected instructions ?',
    deleteQueueResult: 'Are you sure you want to delete this results ?',
    deleteFile: 'Are you sure you want to delete the file ?',
    deleteEntity: 'Are you sure you want to delete this ',
    confirmStatus: 'Are you sure you want to change the status ?',
    saveFileConfirmation: 'Are you sure you want to save the file to file-management?',
    /* Web-Instruction Constants */
    custom: 'CUSTOM',
    completionWaitComp: 'waitComp',
    completionWaitElem: 'waitElem',
    completionNoWait: 'noWait',
    fieldNameLocator: 'webLocator',
    fieldNameLocMandate: 'locatorMandate',
    fieldNameDomExt: 'domExt',

    // Web-Actions
    httpBasicAuth: 'HTTP_BASIC_AUTH',
    pressKey: 'PRESS_KEY',
    move: 'MOVE',
    moveByOffset: 'MOVE_BY_OFFSET',
    sleep: 'SLEEP',
    switchWindow: 'SWITCH_WINDOW',
    scrollHorizontal: 'SCROLL_HORIZONTAL',
    browserFileUpload: 'BROWSER_FILE_UPLOAD',
    executeJS: 'EXECUTE_JS',
    switchToIFrame: 'SWITCH_TO_IFRAME',
    downloadFile: 'DOWNLOAD_FILE',

    // Dom-Extractor Types
    count: 'COUNT',
    existence: 'EXISTENCE',
    ddItemKeys: 'DD_ITEM_KEYS',
    ddItemValues: 'DD_ITEM_VALUES',
    screenCapture: 'SCREEN_CAPTURE',

    /* Performance Lab */
    durationTypeCustom : 'custom',
    defaultTimestamp: '00:00:00',
    defaultLastTimestamp: '23:59:59',
    loadSettingUpdatedInfo: 'Load setting config is getting updated !!!',
    configUpdatedSuccessfullyInfo: 'Config updated successfully',
    informationTechnology: 'Information Technology',
    // eslint-disable-next-line max-len
    emailRegex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

    /* Common */
    typeWeb: 'WEB',
    file: 'FILE',
    failed: 'FAILED',
    passed: 'PASSED',
    endPointTypeWeb: 'WEB',
    testDataPrimary: 'Primary',
    testDataSecondary: 'Secondary ',
    pathExample: 'Ex : /relay-api/endPoints/onboard/{{api}}/count',
    pageUnlabelled: 'UNLABELLED',

     /* Endpoint details - New User */
    newEndpointName:'A unique name to indicate the type or scope of API. Use prefixes, suffixes, or separators',
    newEndpointProject:'Select the Project to add the endpoint to the list',
    newEndpointDescription:'Informative description to explain the purpose or expected outcome',
    newEndpointType:'Select the type of API for testing. It can be either a REST API or SOAP API, Web UI or Mobile Flow',
    newEndpointKeyword:'Add keywords to identify and easy access of specific endpoint from the list of endpoints created',
    newEndpointThreshold:'Define timeout',
    newEndpointSpecificYes:'Allows switching among various app environments like stage, production, and testing',
    newEndpointSpecificNo:'HOST of the API can be hardcoded and added in path section',
    newEndpointAutoRedirect:'If response of the server is a redirection, API will also redirect to the URL',
    newEndpointSanitizeJson:'Parse JSON response and remove extra spaces',
    newEndpointSubflow:'Reuse set of web - instructions across multiple web endpoints',
    newEndpointAuthorization:'Authorization method such as Basic Auth, API Key, Bearer Token, OAuth, etc.',
    newEndpointAuthorizationNone:'No request Authorization required',
    newEndpointAuthorizationBasicAuth:'Involves sending a verified username and password',
    newEndpointHeader:'Request info such as request format, language, authentication credential',
    newEndpointHeaderKey:'Allows single key value headers at a time',
    newEndpointHeaderBulk:'Allow raw paste of multiple headers',
    newEndpointParams:'Enables you to send data along with HTTP requests',
    newEndpointParamsKey:'Appended in url to make an api request',
    newEndpointParamsBulk:'Prefer to enter multiple parameters in plain text',
    newEndpointBody:'Body enables to specify the data to add or update structured data',
    newEndpointFormdata:'Send form-like data',
    newEndpointFormdataKeyvalue:'Send key-value pairs',
    newEndpointFormdataBulk:'Send body in plain text',
    newEndpointRaw:'Option to send anything as text',
    newEndpointBinary:'Transfer non-textual data such as images, videos as binary data',
    newEndpointMultipart:'Combination of one or more sets of data into a single body, Ex:File',

     /* TestCase description details - New User */
     testCaseNameDesc:'Use prefixes, suffixes as naming convention',
     testCaseProjectDesc:'Select the Project to add the testcase to the list',
     testCaseDescriptionDesc:'Informative description to explain the purpose of Test Case',
     testCaseKeywordDesc:'To identify and access specific Test Case',
     testCasePacetimeDesc:'Wait Time',
     
     /* testSuite description details - New User */
     testsuiteNameDesc:'Use prefixes, suffixes as naming convention',
     testsuiteProjectDesc:'Select the Project to add the testsuite to the list',
     testsuiteDescriptionDesc:'Purpose of Test Suite to indicate its scope',

    /* masterSuite description details - New User */
     mastersuiteNameDesc:'Use prefixes, suffixes as naming convention',
     mastersuiteProjectDesc:'Select the Project to add the mastersuite to the list',
     mastersuiteDescriptionDesc:'Purpose of Master Suite to indicate its scope',
   
     /* Test-Case Validations */
    postValidationJump: 'JUMP',
    postValidationExit: 'EXIT',
    postValidationRetry: 'RETRY',
    postValidationSkip: 'SKIP',
    categoryCompare: 'COMPARE',
    optionEqual: 'EQUAL',
    optionNotEqual: 'NOT_EQUAL',
    responseSourceCode: 'RESPONSE_CODE',
    responseSourceBody: 'RESPONSE_BODY',
    responseSourceHeader: 'RESPONSE_HEADER',
    extratorTypeJSFunc: 'JS_FUNCTION',
};

export const errorMessages = {
    /* Web-Instruction */
    nameActionMandatory: 'Please enter Name and select Action !',
    displayNameExists: 'Display name already exist',
    noWIFound: 'No web instruction found for this endpoint',
    domDisplayValueMandatory: 'Display Value is Mandatory !',
    domLocatorMandatory: 'Please select Locator !',
    domInputValueMandatory: 'Please provide required Input Value - (i.e. Cookie Name/Extract From)!',

    /* Queue Component */
    userProjectsError: 'Fetch User Projects Error: ',
    queueListError: 'Fetch Queue List Error: ',

    /*Performance Load Test */
    viewSlotsError: 'Please select to and from date for viewing the available slots...',
    loadDistributeError: 'User distribution should be equal to 100',

    /* Test-Case Validations */
    fetchAsstdEPError: 'Fetch Associated EPs Error: ',
    selectCondition: 'Please select condition',
    fetchResponseExtractorError: 'Fetch Response Extractor Error: ',

    /* Web Locators */
    selectLocatorsInfo: 'Please Select Web-Locators to Save Association',
    
    /* Env.Mapper Force Delete */
    associatedGlobalTestData:'Environment mapper is used in Global test data input files and input values, Can not be deleted',
    associatedGlobalInputKey:'Environment mapper is used in Global test data input values, Can not be deleted',
    associatedGlobalInputFile:'Environment mapper is used in Global test data input files, Can not be deleted',
};
